
export interface AuthorizeCompanyToken {
    token: string;
    refresh_token: string;
}

